/**
 * Display version for footer / chrome.
 * Source of truth: package.json `version`, injected as VITE_VERSION by Vite
 * (and bumped on appci via `npm version patch --no-git-tag-version`).
 */

export function getAppVersionLabel(): string {
  const raw = String(import.meta.env.VITE_VERSION || '').trim();
  if (!raw) {
    return 'v9.1.0';
  }
  return raw.startsWith('v') ? raw : `v${raw}`;
}
